module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/19c403269aab5359128779877d1d9af0.png";